
export const getCredentials = state => state.application.user.credentials;
